import {limit} from "../filters/limit";

require('./bootstrap');
import Vue from 'vue'

window.Vue = Vue;

import i18n from "../plugins/Vue18n";

/*
* ATENÇÃO : REGISTRO APENAS DE COMPONENTES GLOBAIS
* Ao importar um componente dê preferencia a importar localmente.
* */
Vue.component("CycleCarousel", require('./components/CycleCarousel.vue').default);
Vue.component("SmallCalendar", require('./components/schedule/SmallCalendar.vue').default);
Vue.component("EllipseProgress", require('./components/EllipseProgress.vue').default);


import Transitions from 'vue2-transitions';
Vue.use(Transitions)

import Notifications from 'vue-notification';
Vue.use(Notifications)

import VueMoment from 'vue-moment';
import moment from 'moment-timezone';

import VueEllipseProgress from 'vue-ellipse-progress';
Vue.use(VueEllipseProgress);
moment.locale('pt')

Vue.use(VueMoment, {
    moment,
})


Vue.config.productionTip = false

import Vuex from "vuex";
Vue.use(Vuex)

import store from "./store/store";

import VueRouter from 'vue-router';
import router from "./routes";

import Bugsnag from "../plugins/Bugsnag.js";
Bugsnag(store);
import vuetify from "@/plugins/vuetify"
import Highcharts from "@/plugins/Highcharts.js";


import { isInDevelop, isNotInDevelop } from "@/constants/general";

Vue.mixin({
  data() {
    return {
      isInDevelop,
      isNotInDevelop,
    }
  },
  computed:{
    isMobile(){
      return this.$vuetify.breakpoint.mobile
    }
  },
  mounted(){
    setTimeout(() => {
      const preLoadingElement = document.querySelector('#pre-loading');
      if (preLoadingElement) {
        preLoadingElement.remove(); // Remove o elemento de pré-carregamento após 1 segundo
      }
    }, 1000); // Aguarda 1 segundo antes de remover o elemento
  },
})

Vue.use(VueRouter)
new Vue({
    el: '#app',
    i18n,
    vuetify,
    filters: {
        limit,
    },
    store,
    router,
});

